import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

// A section header with an optional count badge that toggles open/closed.
// Used for "The Sources We Used" so the heavy grid is opt-in detail rather
// than the default view.
export default function CollapsibleSection({
  title,
  count,
  defaultOpen = false,
  children,
  testId,
  rightSlot = null,
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between mb-4 group"
        aria-expanded={open}
        data-testid={testId ? `${testId}-toggle` : undefined}
      >
        <h2 className="text-xl sm:text-2xl font-bold text-white tracking-tight flex items-baseline gap-2 text-left">
          {title}
          {typeof count === "number" && count > 0 ? (
            <span className="text-sm text-[#b6c1b8] font-medium tabular-nums">
              ({count})
            </span>
          ) : null}
        </h2>
        <span className="text-[#4ADE80] inline-flex items-center gap-1 text-xs sm:text-sm font-semibold uppercase tracking-[0.14em]">
          {open ? (
            <>
              Hide
              <ChevronUp size={14} />
            </>
          ) : (
            <>
              Show
              <ChevronDown size={14} />
            </>
          )}
        </span>
      </button>
      {rightSlot}
      {open ? children : null}
    </div>
  );
}
